import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MailIcon from '@material-ui/icons/Mail';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';
import { displayErrorMessage, displaySuccess } from 'Helpers/FacetNotificationManager';
import LinkButton from './LinkButton';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(1),
  },
  durationRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  linkRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  icon: {
    fontSize: 18,
    marginRight: theme.spacing(0.5),
  },
  hiddenInput: {
    position: 'absolute',
    left: '-9999px',
  },
});


const copyInstantBookerLink = (text) => {
  const copy = document.getElementById('instantBookerUrl');
  copy.value = text;
  copy.setAttribute('readonly', '');
  copy.select();
  document.execCommand('copy');
};


const AvailabilityPeriodLinkLayout = ({
  className,
  classes,
}) => {
  const { resource: availabilityPeriodLinkResource } = useMetaLayoutContext();
  const isValid = availabilityPeriodLinkResource.isValid();

  const handleSendLink = async () => {
    availabilityPeriodLinkResource.attr('sendEmail', 'true');
    availabilityPeriodLinkResource.attr('sendMessage', 'true');
    try {
      await availabilityPeriodLinkResource.submit();
      displaySuccess('Successfully sent scheduler link to client.');
    } catch (e) {
      displayErrorMessage(e, 'Failed to send scheduler link to client.');
    }
  };

  const handleCopyLink = async () => {
    availabilityPeriodLinkResource.attr('sendEmail', 'false');
    availabilityPeriodLinkResource.attr('sendMessage', 'false');
    try {
      const [newLinkResource] = await availabilityPeriodLinkResource.submit();
      const link = newLinkResource.attr('link');
      copyInstantBookerLink(link);
      displaySuccess('Copied scheduler link to your clipboard.');
    } catch (e) {
      displayErrorMessage(e, 'Failed to copy link to clipboard.');
    }
  };


  return (
    <Box
      className={classNames(classes.root, className)}
      boxShadow={2}
    >
      <MetaControlField attr="meetingType" />
      <MetaControlField attr="blockType" />
      <div className={classes.durationRow}>
        <MetaControlField attr="duration" />
        <MetaControlField attr="bufferDuration" />
      </div>
      <MetaControlField attr="cadence" />
      <div className={classes.linkRow}>
        <LinkButton
          icon={<MailIcon className={classes.icon} />}
          label="Send Link"
          disabled={!isValid}
          onClick={handleSendLink}
        />
        <LinkButton
          icon={<FontAwesome className={classes.icon} icon="link" />}
          label="Copy Link"
          disabled={!isValid}
          onClick={handleCopyLink}
        />
        {/*  hidden input field to allow copying to work */}
      </div>
      <input id="instantBookerUrl" type="textarea" className={classes.hiddenInput} />
    </Box>
  );
};

AvailabilityPeriodLinkLayout.defaultProps = {
  className: '',
};

AvailabilityPeriodLinkLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AvailabilityPeriodLinkLayout);
